import { useI18n } from '@wordpress/react-i18n';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
export default function SidebarModal({ open, type, children }) {
    const [portalEl, setPortalEl] = useState(null);
    useEffect(() => {
        let sidebar = document.querySelector('div.ltg-modal-sidebar');
        if (!open && sidebar) {
            sidebar.remove();
            setPortalEl(null);
            return;
        }
        ;
        if (!open) {
            return;
        }
        ;
        let portal = sidebar;
        if (!portal && type == 'mobile') {
            portal = document.createElement('div');
            portal.classList.add('ltg-modal-sidebar');
            document.body.append(portal);
        }
        ;
        if (!portal) {
            portal = document.createElement('div');
            portal.classList.add('ltg-modal-sidebar');
            document.body.append(portal);
        }
        ;
        setPortalEl(portal);
    }, [open]);
    if (portalEl && open) {
        return ReactDOM.createPortal(children, portalEl);
    }
}
;
export function SidebarControllers({ isFilters, handleCloseMenu, handleClearFilters }) {
    const { __ } = useI18n();
    return (React.createElement("div", { className: 'ltg-modal-sidebar-wrap-content-controller' },
        React.createElement("button", { className: 'ltg-modal-sidebar-wrap-content-controller-button', onClick: () => {
                handleCloseMenu();
            } },
            React.createElement("span", { className: "sr-only" }, __('Uždaryti filtrus', 'ltg-widgets')),
            React.createElement("svg", { viewBox: '0 0 24 24', width: '25px', height: '25px', className: 'ltg-modal-sidebar-wrap-content-controller-button-icon' },
                React.createElement("line", { x1: "0", y1: "12", x2: "8", y2: "18", stroke: 'black', className: 'ltg-modal-sidebar-wrap-content-controller-button-icon-line' }),
                React.createElement("line", { x1: "0", y1: "12", x2: "8", y2: "6", stroke: 'black', className: 'ltg-modal-sidebar-wrap-content-controller-button-icon-line' }))),
        isFilters && React.createElement("button", { type: 'button', className: 'ltg-modal-sidebar-wrap-content-controller-button', onClick: () => {
                handleClearFilters();
            } }, __("išvalyti visus filtrus", 'ltg-widgets'))));
}
;
